import { useTranslation } from "react-i18next";
import i18n from "locales/i18n";

import PageWrapper from "components/page/PageWrapper";
import EducationBox from './EducationBox';
import bg from 'assets/images/banner/banner02.jpg';

import mobileKo from 'assets/images/solutions/onm/ko/onm_02_mobile.jpg';
import pcKo from 'assets/images/solutions/onm/ko/onm_02_pc.png'
import mobileEn from 'assets/images/solutions/onm/en/onm_02_mobile.jpg';
import pcEn from 'assets/images/solutions/onm/en/onm_02_pc.png'

import onmKo from 'assets/images/solutions/onm/ko/onm_01.png'
import onmEn from 'assets/images/solutions/onm/en/onm_01.png'

export default function OnM(){
  const {t} = useTranslation();
  const locale = i18n.language??'ko';
  const menuName= t('menu.sub-o_m');
  const path=[
    {url:'/solutions', name:t('menu.main-solutions')},
    {url:'/solutions/onm', name:menuName}];
  const title = t('onm.banner.title')
  const comment = t('onm.banner.comment')

  const imgs={
    ko:{mobile:mobileKo, pc:pcKo},
    en:{mobile:mobileEn, pc:pcEn}
  }

  const imgOnM = {ko:onmKo, en:onmEn}

  const educations = [];
  for(let i = 1; i< 4; i++){
    const education = {
      title:t(`onm.body.process-${i}.title`),
      comment1:t(`onm.body.process-${i}.comment-1`),
      comment2:t(`onm.body.process-${i}.comment-2`)
    };
    educations.push(education);
  }

  const comment3 = t('onm.body.comment-4');

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
    <div className="flex flex-row justify-center mt-5 mb-10 lg:my-20">
      <div className="flex flex-col px-mobile lg:w-[1200px]">
        <div className="flex flex-col justify-between lg:items-center lg:flex-row"> {/* 상단 파트 */}
          <div className="flex flex-col ">
            <p className="mb-4 text-2xl lg:text-3xl font-extralight lg:mb-10">
              <span className=" text-hover">{t('onm.body.title-1')} </span>
              {t('onm.body.title-2')}
            </p>
            {[1, 2, 3].map(i=> (
              <p key={i} className="mb-4 text-xs text-gray-500 lg:text-lg lg:mb-10" 
              dangerouslySetInnerHTML={{__html:t(`onm.body.comment-${i}`)}}></p>
            ))}
            
          </div>
          <div>
            <img src={imgOnM[locale]} alt='O&M'/>
          </div>
        </div>
        <div className="flex flex-col"> {/* 교육 프로세스 */}
          <p className="mt-20 mb-10 text-sm font-light lg:text-xl" dangerouslySetInnerHTML={{__html:comment3}}></p>
          <p className="mb-4 font-semibold text-hover">{t('onm.body.image-title')}</p>
          <picture>
            <source media="(min-width: 1024px)" srcSet={imgs[locale].pc}/>
            <img src={imgs[locale].mobile} alt='edcucation process'/>
          </picture>
        </div>
        <div className="flex flex-col mt-10 lg:mt-20">
          <p className="font-semibold text-hover">{t('onm.body.process-title')}</p>
          <div className="flex flex-col items-center mt-4 lg:items-stretch lg:flex-row"> {/* 교육 내용 파트*/}
            {educations.map((e, index) =>{
              return <EducationBox key={index} className={`${index===1? "lg:mx-10":""}`}title={e.title} comment1={e.comment1} comment2={e.comment2}/>
            })}
          </div>
        </div>
      </div>
    </div>
    </PageWrapper>
  );
}